import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess202001Status: 'idle',
    startProcess202001Error: undefined as any,
    loadUserParamsProcess202001Status: 'idle',
    loadUserParamsProcess202001Error: undefined as any,

    process202001List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess202001 = createAsyncThunk('process202001Slice/startProcess202001', async ({ process202001 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess202001/`,
        prepareData(process202001),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess202001Status } = getState().process202001Slice
        return startProcess202001Status !== 'pending'
    }
})

export const loadUserParamsProcess202001 = createAsyncThunk('process202001Slice/loadUserParamsProcess202001', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess202001/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess202001Status } = getState().process202001Slice
        return loadUserParamsProcess202001Status !== 'pending'
    }
})

const Process202001Slice = createSlice({
    name: 'process202001Slice',
    initialState,
    reducers: {
        resetstartProcess202001: (state) => {
            state.job = undefined
            state.startProcess202001Error = undefined
        },
        resetstartProcess202001Error: (state) => {
            state.startProcess202001Error = undefined
        },
        resetloadUserParamsProcess202001: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess202001Error = undefined
        },
        resetloadUserParamsProcess202001Error: (state) => {
            state.loadUserParamsProcess202001Error = undefined
        },
        removeFromProcess202001ListById: (state, action) => {
            state.process202001List = state.process202001List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess202001ListByIds: (state, action) => {
            state.process202001List = state.process202001List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process202001List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess202001Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process202001List = []
            state.startProcess202001Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess202001.pending, (state) => {
            state.startProcess202001Status = 'pending'
            state.startProcess202001Error = undefined
        })
        builder.addCase(startProcess202001.fulfilled, (state, action) => {
            state.startProcess202001Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess202001.rejected, (state, action) => {
            state.startProcess202001Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess202001Error = action.error.message
            } else {
                state.startProcess202001Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess202001.pending, (state) => {
            state.loadUserParamsProcess202001Status = 'pending'
            state.loadUserParamsProcess202001Error = undefined
        })
        builder.addCase(loadUserParamsProcess202001.fulfilled, (state, action) => {
            state.loadUserParamsProcess202001Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess202001.rejected, (state, action) => {
            state.loadUserParamsProcess202001Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess202001Error = action.error.message
            } else {
                state.loadUserParamsProcess202001Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess202001,
    resetstartProcess202001Error,
    resetloadUserParamsProcess202001,
    resetloadUserParamsProcess202001Error,
    removeFromProcess202001ListById,
    removeFromProcess202001ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process202001Slice.actions
export default Process202001Slice.reducer
